import {AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit, ViewChild, ChangeDetectorRef} from '@angular/core';
import {DecimalPipe} from '@angular/common';
import {Title} from '@angular/platform-browser';
import {DateFilterService} from '../../../../Services/dateFilter.service';
import {DataService} from '../../../../Services/data.service';
import {StorageService} from '../../../../Services/storage.service';
import {ActivatedRoute, Router} from '@angular/router';
import {FilterPipe} from 'ngx-filter-pipe';
import {DataExportService} from '../../../../Services/dataExport.service';
import {DatePipe} from '@angular/common';
import {AppConfigService} from '../../../../Services/app-config.service';
import {ResponseModel} from '../../../../DataModels/response-model';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {PaymentModel} from '../../../../DataModels/payment-model';
import {take} from 'rxjs/operators';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';
import {EmailModel} from '../../../../DataModels/email-model';
import { RoutingTrackerService} from '../../../../Services/routing-tracker.service';
import {Modal} from 'bootstrap';
import {SysUserModel} from '../../../../DataModels/sys-user-model';
import {HelperService} from '../../../../Services/helper/helper.service';
import {ReportPrintService} from '../../../../Services/report-print.service';
import {PermissionsService} from '../../../../Services/permissions.service';

@Component({
  selector: 'app-aging',
  templateUrl: './aging.component.html',
  styleUrls: ['./aging.component.css'],
  standalone: false
})
export class AgingComponent implements OnInit, AfterViewInit, AfterViewChecked {
  @ViewChild('mainTable', {static: false}) EmailContent: ElementRef;

  public urlParams: any = [];
  hideDetails;
  private rptName: string;
  public vm: any = {
    report: [],
    subLedger: null,
    request: {
      toDate: null,
      includeUnposted: false,
      entity_id: null,
      entity_type_id: null,
      company_id: null,
      currency_id: null,
    },
    entityType: [],
    company: [],
    location: [],
    payTotals: null,
    buttonsDisabled: false,
    payment: {
      total: null,
    },
    showFilters: false,
    entityFilter: {
      name: null,
    },
    currency: [],
    entity: [],
    entity_type: [],
    entityInput: null,
    ToEmailError: null,
    showEmail: true,
    ToEmail: null,
    emailed: null,
    email: {
      toemail: null,
      fromemail: this.applicationConfig.SysEmailAddress,
      PdfHtml: null,
      Subject: null,
    },
    ToEmailEntity: false,
    permissions: {
      Admin: null,
      AllEntities: null,
    },
    totalOwing: null,
    totalCurrent: null,
    total1to30: null,
    total31to60: null,
    total61to90: null,
    total91plus: null,
    entity_email: null,
    entityName: [],
    startEntity: 0,
    batchName: [],
    batchFilter: {search_string: ''},
    toDateSelect: [],
    monthCount: [],
    exportToExcel: true,
  };

  flatRows: any[] = [];

  checkAllCheckBox = false;
  printDocIdList: {
    id: string,
    bank_id: string
  }[] = [];

  printDocIds = [];
  selectItem; any = [];
  user: SysUserModel;
  routedFrom = '';
  checkAll = false;

  invoicesToPay: PaymentModel = new PaymentModel();
  invoiceArrayToSendToApi = [];
  invoiceSelectedCount = 0;
  currentEntityForErrorReporting = '';
  invoiceFound = false;
  // const category: Category = new Category();

  // email stuff - add app-button-email-new to html also
  buttonConfig: any = {
    reportFormat: false,
    print: false,
    printReport: true,
    email: true,
    update: true,
    exportExcel: true,
    close: true,
  };
  reportDataToSendInEmail: EmailModel = new EmailModel();


  constructor(
    private titleService: Title,
    public dateFilter: DateFilterService,
    public tableDataService: DataService,
    public notification: BsToastService,
    public localStorage: StorageService,
    private route: ActivatedRoute,
    private router: Router,
    public excelExporter: DataExportService,
    public datePipe: DatePipe,
    public applicationConfig: AppConfigService,
    private confirmDialogService: ConfirmDialogService,
    public prevUrl: RoutingTrackerService,
    private cd: ChangeDetectorRef,
    private helperService: HelperService,
    private reportPrint: ReportPrintService,
    private permissionsService: PermissionsService
  ) {

    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));

    const prevUrl2 = this.prevUrl.getPreviousUrl();

    if (prevUrl2 !== null && prevUrl2 !== undefined) {
      this.routedFrom = prevUrl2;
    } else {
      this.routedFrom = '';
    }
  }


  get hasAdminOrAllEntities(): boolean {
    return this.permissionsService.Get('Admin') ||
      this.permissionsService.Get('AllEntities');
  }

  ngOnInit() {

    this.user = JSON.parse(localStorage.getItem('currentUser'));

    this.invoicesToPay.applied = [];

    this.urlParams = this.route.snapshot.queryParams;

    this.vm.request.entity_id = this.urlParams.entity_id;
    if (this.vm.request.entity_id) {
      this.vm.filtered = true;
    }

    const hasUrlToDate = this.urlParams.toDate !== undefined;
    if (hasUrlToDate) {
      this.vm.request.toDate = this.urlParams.toDate;
    } else {
      const now = new Date();
      const monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      this.vm.request.toDate = this.dateFilter.GetDateFormat(monthEnd);
    }

    this.vm.subLedger = this.urlParams.subLedger;

    this.FilterOptionsInit().then(() => {
      if (hasUrlToDate && this.vm.request.toDate) {
        this.update();
      }
    });
    this.rptName = this.vm.subLedger.toUpperCase() + ' ' + $localize`:Aging Report @@agingReport:Aging Report`;

    if (this.vm.subLedger === 'ap') {
      // sets Report Fromat checkbox on off
      this.vm.report_format = true;
    }

  }

  exportToExcel() {
    const name = this.vm.subLedger.toUpperCase() + ' Aging Report.xlsx';
    const html = this.buildExportHtml();
    this.excelExporter.exportHtmlToExcel(html, name);
  }

  async FilterOptionsInit() {
    this.tableDataService.getData('currency?state=active&pageNumber=0&pageSize=99999').subscribe((result: ResponseModel) => {
      this.vm.currency = result;
    });
    this.tableDataService.getData('company?state=active&pageNumber=0&pageSize=99999').subscribe((result: ResponseModel) => {
      this.vm.company = result.Data;
    });
    this.tableDataService.getData('bank?state=active&pageNumber=0&pageSize=99999').subscribe((result: ResponseModel) => {
      this.vm.bank = result.Data;
    });
    this.tableDataService.getData('entity_type?state=active&pageNumber=0&pageSize=99999').subscribe((result: ResponseModel) => {
      // const data: any = result.Data;
      this.vm.entityType = result.Data;
    });

    this.vm.entity = await this.getFilterValues('entity', '?state=active');
    for (const [x, value] of Object.entries(this.vm.entity || {})) {
      this.vm.entityName.push({name: this.vm.entity[x].name});
    }

    if (this.urlParams.entity_id != null || this.urlParams.entity_id != undefined) {
      for (const [y, value] of Object.entries(this.vm.entity || {})) {
        if (this.vm.entity[y]) {
          if (this.vm.entity[y].id == this.urlParams.entity_id) {
            this.vm.entityInput = this.vm.entity[y].name;
            this.vm.request.entity_id = this.vm.entity[y].id;
            this.vm.request.entity_email = this.vm.entity[y].email;
            break;
          }
        }
      }
    }
  }

  // Print the report content using a generated HTML document (do not use PrintService)
  printReport() {
    try {
      const html = this.buildPrintHtml();
      this.reportPrint.printInIframe(html);
    } catch (e) {
      console.error('Aging print failed', e);
      this.notification?.showWarningToast?.('Unable to print Aging Report');
    }
  }

  async getFilterValues(tablename, param) {
    let values: any;
    values = null;
    await this.tableDataService.getData(tablename + param + '&pageNumber=0&pageSize=99999').toPromise().then((result: ResponseModel) => {
      const data: any = result.Data;
      values = data;
    });
    // this.localStorage.StorageSet(tablename, JSON.stringify(values));
    return values;
  }


  ngAfterViewInit() {
    this.titleService.setTitle(this.rptName);
  }

  ngAfterViewChecked() {

  }

  async setEmailData() {
    // console.log('setEmailData');
    // prepare email object and open local modal instance
    await this.getReportData(true);

    // Ensure Angular propagates @Input changes to the modal before opening it
    try {
      this.cd.detectChanges();
    } catch {
    }

    const openModal = () => {
      // Show the shared Send Email modal directly
      const element = document.getElementById('sendEmailModal') as HTMLElement;
      if (element) {
        const emailModal = new Modal(element);
        emailModal.show();
      }
    };

    // Open on next tick to allow bindings to settle
    setTimeout(openModal, 0);
  }

  async getReportData(event: any) {
    const eventSent: any = event;
    const emailDocObj = {} as EmailModel;
    let reportName = 'Aging Report';

    if (this.vm.subLedger === 'ap') {
      reportName = 'AP Aging Report';
    } else if (this.vm.subLedger === 'ar') {
      reportName = 'AR Aging Report';
    }

    // printing options
    emailDocObj.print_orientation = '2';
    emailDocObj.convert_attachment_to = 'pdf';

    emailDocObj.fromEmail = '';
    emailDocObj.fromName = 'AcctXErp';
    emailDocObj.header_id = '';
    emailDocObj.toEmail = this.vm?.request?.entity_email
      || this.vm?.entity_email
      || this.vm?.ToEmail
      || '';
    emailDocObj.body = 'Please see the attached ' + reportName + '.<br><br><br>'
      + 'Best regards,'
      + '<br><br>'
      + 'AcctXErp'
      + '<br><br>';
    emailDocObj.Subject = 'AcctXErp ' + reportName;

    // Ensure hidden email/print markup is rendered before building HTML
    this.vm.showEmail = true;
    try {
      this.cd.detectChanges();
    } catch {
    }
    await new Promise((resolve) => setTimeout(resolve, 0));

    // Use the same HTML as printing to ensure consistency
    try {
      emailDocObj.pdfHtml = this.buildPrintHtml(true);
    } catch {
      emailDocObj.pdfHtml = '';
    }
    emailDocObj.activity_message = reportName;

    // deterministic file name
    const now = new Date();
    const yyyy = String(now.getFullYear());
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    const prefix = this.vm.subLedger === 'ap' ? 'AP_Aging_Report' : (this.vm.subLedger === 'ar' ? 'AR_Aging_Report' : 'Aging_Report');
    emailDocObj.FileName = `${prefix}_${yyyy}${mm}${dd}.pdf`;
    // console.log('emailDocObj.FileName: ', emailDocObj);
    this.reportDataToSendInEmail = emailDocObj;
  }

  // Build export/print table HTML from data (no DOM dependency)
  private buildExportHtml(): string {
    const fmt = (v: number) => new DecimalPipe('en-US').transform(Math.abs(v), '1.2-2') || '0.00';
    const pct = (v: number, total: number) => total ? (new DecimalPipe('en-US').transform((v / total) * 100, '1.0-0') || '0') + '%' : '';
    const cell = (v: number) => v >= 0 ? fmt(v) : `(${fmt(v)})`;
    const td = (content: string, style = '') => `<td style="text-align:right;border-bottom:1px solid #ccc;${style}">${content}</td>`;
    const thStyle = 'border-bottom:2px solid #888;text-align:right;';
    const rows: string[] = [];
    const report: any[] = this.vm.report || [];
    for (const r of report) {
      if (!this.hideDetails) {
        rows.push(`<tr style="font-weight:bold"><td colspan="9" style="border-bottom:2px solid #aaa">${r.name}</td></tr>`);
        for (const i of (r.invoices || [])) {
          const doc = `${i.document || ''}: ${i.number || ''}`;
          const dateStr = i.header_date ? new Date(i.header_date).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          }) : '';
          const dueStr = i.due_date ? new Date(i.due_date).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          }) : '';
          rows.push(`<tr>
            <td style="border-bottom:1px solid #ccc">${doc} ${i.description || ''}</td>
            <td style="border-bottom:1px solid #ccc;text-align:center">${dateStr}</td>
            <td style="border-bottom:1px solid #ccc;text-align:center">${dueStr}</td>
            ${td(i.amount >= 0 ? fmt(i.amount) : `(${fmt(i.amount)})`)}
            ${td(cell(i.owing))}
            ${td(i.days_late <= 0 ? cell(i.owing) : '')}
            ${td(i.days_late > 0 && i.days_late <= 30 ? cell(i.owing) : '')}
            ${td(i.days_late > 30 && i.days_late <= 60 ? cell(i.owing) : '')}
            ${td(i.days_late > 60 && i.days_late <= 90 ? cell(i.owing) : '')}
            ${td(i.days_late > 90 ? cell(i.owing) : '')}
          </tr>`);
        }
      }
      rows.push(`<tr style="text-align:right">
        <td colspan="4" style="border-bottom:1px solid #ccc;text-align:left">${!this.hideDetails ? 'Total ' : ''}${r.name}</td>
        ${td(cell(r.totalOwing) + '<br><small>100%</small>')}
        ${td(cell(r.totalCurrent) + (r.totalCurrent ? `<br><small>${pct(r.totalCurrent, r.totalOwing)}</small>` : ''))}
        ${td(cell(r.total1to30) + (r.total1to30 ? `<br><small>${pct(r.total1to30, r.totalOwing)}</small>` : ''))}
        ${td(cell(r.total31to60) + (r.total31to60 ? `<br><small>${pct(r.total31to60, r.totalOwing)}</small>` : ''))}
        ${td(cell(r.total61to90) + (r.total61to90 ? `<br><small>${pct(r.total61to90, r.totalOwing)}</small>` : ''))}
        ${td(cell(r.total91plus) + (r.total91plus ? `<br><small>${pct(r.total91plus, r.totalOwing)}</small>` : ''))}
      </tr>`);
    }
    let tfoot = '';
    if (report.length > 1) {
      tfoot = `<tfoot><tr style="text-align:right;font-weight:bold">
        <td colspan="4" style="border-top:2px solid #888">Report Total</td>
        ${td(cell(this.vm.totalOwing) + '<br><small>100%</small>', 'border-top:2px solid #888;')}
        ${td(cell(this.vm.totalCurrent) + `<br><small>${pct(this.vm.totalCurrent, this.vm.totalOwing)}</small>`, 'border-top:2px solid #888;')}
        ${td(cell(this.vm.total1to30) + `<br><small>${pct(this.vm.total1to30, this.vm.totalOwing)}</small>`, 'border-top:2px solid #888;')}
        ${td(cell(this.vm.total31to60) + `<br><small>${pct(this.vm.total31to60, this.vm.totalOwing)}</small>`, 'border-top:2px solid #888;')}
        ${td(cell(this.vm.total61to90) + `<br><small>${pct(this.vm.total61to90, this.vm.totalOwing)}</small>`, 'border-top:2px solid #888;')}
        ${td(cell(this.vm.total91plus) + `<br><small>${pct(this.vm.total91plus, this.vm.totalOwing)}</small>`, 'border-top:2px solid #888;')}
      </tr></tfoot>`;
    }
    return `<table width="100%" cellpadding="4" cellspacing="0" style="border-collapse:collapse">
      <thead><tr>
        <th style="${thStyle}text-align:left">Entity / Document</th>
        <th style="${thStyle}text-align:center">${!this.hideDetails ? 'Date' : ''}</th>
        <th style="${thStyle}text-align:center">${!this.hideDetails ? 'Due' : ''}</th>
        <th style="${thStyle}text-align:right">${!this.hideDetails ? 'Original' : ''}</th>
        <th style="${thStyle}">Balance</th>
        <th style="${thStyle}">Current</th>
        <th style="${thStyle}">1 to 30</th>
        <th style="${thStyle}">31 to 60</th>
        <th style="${thStyle}">61 to 90</th>
        <th style="${thStyle}">91+</th>
      </tr></thead>
      <tbody>${rows.join('')}</tbody>
      ${tfoot}
    </table>`;
  }

  // Build a self-contained HTML for printing/emailing the current report
  private buildPrintHtml(forEmail: boolean = false): string {
    const rawContent = this.buildExportHtml();
    const content = this.reportPrint.cleanContentHtml(rawContent);
    let title = 'Aging Report';
    if (this.vm?.subLedger === 'ap') {
      title = 'AP Aging Report';
    } else if (this.vm?.subLedger === 'ar') {
      title = 'AR Aging Report';
    }
    const toDate = this.vm?.request?.toDate ? String(this.vm.request.toDate) : '';
    const meta: { label: string; value: string }[] = [];
    if (toDate) {
      meta.push({label: 'As of', value: toDate});
    }
    return this.reportPrint.buildHtml({title, contentHtml: content, meta, orientation: 'landscape'});
  }

  update() {
    this.vm.buttonsDisabled = true;
    this.vm.report = [];
    this.vm.request.toDate = this.dateFilter.GetDateFormat(this.vm.request.toDate);
    const urlParamsJson = {
      toDate: this.vm.request.toDate,
      subLedger: this.vm.subLedger,
      entity_id: this.vm.request.entity_id,
      entity_type_id: this.vm.request.entity_type_id,
      company_id: this.vm.request.company_id,
      currency_id: this.vm.request.currency_id
    };
    const urlParams: string = this.encodeQueryData(urlParamsJson);
    this.tableDataService.getData('aging', '?' + urlParams).subscribe((result) => {
      this.vm.report = result;
      this.calcReportTotals();
      this.buildFlatRows();
      this.vm.buttonsDisabled = false;
    });
  }

  toggleHideDetails() {
    this.hideDetails = !this.hideDetails;
    this.buildFlatRows();
  }

  buildFlatRows() {
    const rows: any[] = [];
    for (const r of (this.vm.report || [])) {
      if (!this.hideDetails) {
        rows.push({type: 'entity-header', r});
        for (const i of ((r.invoices || []).slice().sort((a: any, b: any) => {
          const da = a.due_date ? new Date(a.due_date).getTime() : 0;
          const db = b.due_date ? new Date(b.due_date).getTime() : 0;
          return da - db;
        }))) {
          rows.push({type: 'invoice', r, i});
        }
      }
      rows.push({type: 'entity-total', r});
      if (!this.hideDetails) {
        rows.push({type: 'cumulative', r});
      }
    }
    this.flatRows = rows;
  }

  encodeQueryData(data) {
    const ret = [];
    for (const d in data) {
      if (data[d] != null && data[d] != '') {
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
      }
    }
    return ret.join('&');
  }

  createPaymentApplyRecords() {

    try {
      // new obj each run - also reset inside each loop run - see code below
      this.invoicesToPay = new PaymentModel();
      this.invoicesToPay.applied = [];
      this.invoicesToPay.detail = [];
      this.invoiceArrayToSendToApi = [];
      this.invoiceSelectedCount = 0;
      this.currentEntityForErrorReporting = '';
      this.invoiceFound = false;

      this.vm.report.forEach((item) => {

        if (item.selected === true) {
          const hdrEntityData = this.vm.entity.filter(x => x.id === item.id);
          this.currentEntityForErrorReporting = item.name;
          this.invoiceFound = true;
          let detailTotal = 0;
          const postDesc = this.datePipe.transform(Date.now(), 'medium');

          this.invoicesToPay.header = {
            header_date: this.datePipe.transform(Date.now(), 'MM/dd/yyyy'),
            currency_rate: '1',
            entity_id: item.id,
            entityInput: item.name,
            company_id: hdrEntityData[0].company_id,
            description: 'Selected for payment from Aging by user: ' + this.user.name + ' on ' + postDesc,
            bank_id: hdrEntityData[0].bank_id,
            payment_type_id: hdrEntityData[0].payment_type_id
          };

          this.invoicesToPay.batch = {
            type_id: '5',
            description: 'Batch'
          };

          item.invoices.forEach((inv) => {
            if (inv.selected === true && item.id === inv.entity_id) {
              // persists to get TOTAL count of invoices selected
              this.invoiceSelectedCount++;
              // resets on each unique loop from above
              detailTotal = detailTotal + inv.amount;

              const applied = {
                applied_header_id: inv.id,
                applied_amount: inv.amount,
                applied_date: inv.header_date
              };
              this.invoicesToPay.applied.push(applied);
            }
          });

          const cashAccount = this.vm.bank.filter(x => x.id === hdrEntityData[0].bank_id);

          const detail = {
            id: 1,
            amount: detailTotal,
            debit_credit: detailTotal,
            account_id: cashAccount[0].account_id
          };
          this.invoicesToPay.detail.push(detail);

          this.invoiceArrayToSendToApi.push(this.invoicesToPay);
          // cleanup after write to array and before next loop
          this.invoicesToPay = new PaymentModel();
          this.invoicesToPay.applied = [];
          this.invoicesToPay.detail = [];
        }

      });
    } catch (e) {
      this.notification.showWarningToast('Entity ' + this.currentEntityForErrorReporting + ' does not have all default values set, ' +
        ' or one of its default items is not completely setup with its defaults. Entries for this Entity cannot be generated until ' +
        ' all default values are set. De-select the Entity or complete the setup.');
      console.log(e.message + ' Entity: ' + this.currentEntityForErrorReporting);
      // uncheck all rows since we are not sure
      this.selectAllRows(false);
      return;
    }

    if (!this.invoiceFound) {
      this.notification.showWarningToast('No Invoices found. Please be sure to select at least one invoice.');
      return;
    }

    // good to here - verify they want to post and post on affirm
    this.confirmPost(this.invoiceSelectedCount);
  }

  postPayment() {
    // console.log('invoice array at post: ' + JSON.stringify(this.invoiceArrayToSendToApi));
    this.tableDataService.post('entry/PostByArray', this.invoiceArrayToSendToApi).pipe(take(1))
      .subscribe({
        next: (result: any) => {
          // console.log('posted: ' + result.Message);
        },
        error: (err: any) => {
          console.error(err.message);
        },
        complete: () => {
          this.update();
        },
      });
    //
    //
    // console.log('posting AP: ' + JSON.stringify(this.vm.item));
    // this.tableDataService.post('entry', this.vm.item).subscribe(
    //   (result: any) => {
    //     // this.notification.success(result.description);
    //     if (this.vm.action === 'new') {
    //       this.vm.buttonsDisabled = false;
    //       this.vm.invoices = [];
    //       this.vm.applied = [];
    //       // this.notification.info($localize`:New @@new:New`);
    //       this.vm.action = '';
    //       //   const str = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    //       //   if (this.vm.subLedger === 'ap') {
    //       //     this.router.navigateByUrl('/transactions/payment/form?paymentId=newAP&new=' + str).then();
    //       //   } else {
    //       //     this.router.navigateByUrl('/transactions/payment/form?paymentId=newAR&action=' + str).then();
    //       //   }
    //       // } else {
    //       this.vm.buttonsDisabled = false;
    //       this.router.navigateByUrl('/transactions/payment/form?paymentId=' + result.id).then();
    //     }
    //   },
    //   (error2: any) => {
    //     this.vm.buttonsDisabled = false;
    //     let ErrorMsg: string;
    //     if (typeof error2.error.Message !== 'undefined') {
    //       ErrorMsg = error2.error.Message;
    //     } else {
    //       ErrorMsg = error2.statusText;
    //     }
    //     this.notification.showErrorToast(ErrorMsg);
    //   }
    // );

  }

  confirmPost(invoiceCount: any) {
    const messages: string[] = [
      $localize`:Post selected Invoices to Payments? @@postselectedinvoicestopayments?:Post selected Invoices to Payments?`,
      'Invoice selected count = ' + invoiceCount
    ];
    this.confirmDialogService.confirmThis(
      messages,
      () => {
       this.postPayment();
        // alert('at post');
        // console.log('invoice array at post: ' + JSON.stringify(this.invoiceArrayToSendToApi));
      },
      () => {
        this.notification.showSuccessToast($localize`:Post Canceled @@postCanceled:Post Canceled`);
      }
    );
  }

  cleanUpCancelledInvoicePost() {

  }

  selectRow(rec: any, event: Event) {
    // console.log('select single rec val:' + rec + ' - ' + checked);
    const checkbox = event.target as HTMLInputElement;
    const value = checkbox.value;
    const checked = checkbox.checked;
    if (this.checkAll && rec) {
      this.checkAll = false;
    }
    if (!checked) {
      this.vm.report.forEach((item) => {
        item.invoices.forEach((inv) => {
          if (inv.id === rec) {
            inv.selected = false;
            item.selected = false;
          }
        });
      });
    } else if (checked) {
      this.vm.report.forEach((item) => {
        item.invoices.forEach((inv) => {
          if (inv.id === rec) {
            inv.selected = true;
            item.selected = true;
          }
        });
      });
      }

    this.isAllChecked();
    // console.log ('after single row select: ' + JSON.stringify(this.vm.report));
  }

  selectAllRows(event: any) {
    // console.log('select all rec val:' + event);
    if (!event) {
      this.vm.report.forEach((item) => {
        item.invoices.forEach((inv) => {
          inv.selected = false;
          item.selected = false;
        });
      });
      this.checkAll = false;
    } else if (event) {
      this.vm.report.forEach((item) => {
        item.invoices.forEach((inv) => {
          inv.selected = true;
          item.selected = true;
        });
      });
      this.checkAll = true;
    }
    // console.log('all select records: ' + JSON.stringify(this.vm.report));
  }

  isAllChecked(): boolean {
    let retVal = true;

    this.vm.report.forEach((item) => {
      item.invoices.forEach((inv) => {
       if (inv.selected === false || inv.sellected === undefined) {
         retVal = false;
         // console.log('not all checked');
       }
     });
    });
    this.checkAll = retVal;
    // console.log('is all  return: ' + retVal);
    return retVal;
  }

  close() {
    if (this.routedFrom) {
      this.router.navigateByUrl(this.routedFrom).then();
    } else if (this.routedFrom === '' || this.routedFrom === undefined) {
      window.close();
    } else {
      this.router.navigateByUrl('/home').then();
    }
  }

  clear() {
    this.vm.request = {
      toDate: null,
      includeUnposted: false,
      entity_id: null,
      entity_type_id: null,
      company_id: null,
      currency_id: null,
    };
    this.vm.report = [];
    this.vm.entityInput = '';
  }

  calcReportTotals() {
    let reportBalance = 0;
    let reportCurrent = 0;
    let report1 = 0;
    let report30 = 0;
    let report60 = 0;
    let report90 = 0;

    for (const [x, value] of Object.entries(this.vm.report)) {
      let entityOwing = 0;
      let entityCurrent = 0;
      let entity1 = 0;
      let entity30 = 0;
      let entity60 = 0;
      let entity90 = 0;
      for (const [y, value2] of Object.entries(this.vm.report[x].invoices)) {
        entityOwing += this.vm.report[x].invoices[y].owing;
        if (this.vm.report[x].invoices[y].days_late <= 0) {
          entityCurrent += this.vm.report[x].invoices[y].owing;
        } else if (this.vm.report[x].invoices[y].days_late <= 30) {
          entity1 += this.vm.report[x].invoices[y].owing;
        } else if (this.vm.report[x].invoices[y].days_late <= 60) {
          entity30 += this.vm.report[x].invoices[y].owing;
        } else if (this.vm.report[x].invoices[y].days_late <= 90) {
          entity60 += this.vm.report[x].invoices[y].owing;
        } else {
          entity90 += this.vm.report[x].invoices[y].owing;
        }
      }
      reportBalance += entityOwing;
      reportCurrent += entityCurrent;
      report1 += entity1;
      report30 += entity30;
      report60 += entity60;
      report90 += entity90;
      this.vm.report[x].totalOwing = entityOwing;
      this.vm.report[x].totalCurrent = entityCurrent;
      this.vm.report[x].total1to30 = entity1;
      this.vm.report[x].total31to60 = entity30;
      this.vm.report[x].total61to90 = entity60;
      this.vm.report[x].total91plus = entity90;
    }
    this.vm.totalOwing = reportBalance;
    this.vm.totalCurrent = reportCurrent;
    this.vm.total1to30 = report1;
    this.vm.total31to60 = report30;
    this.vm.total61to90 = report60;
    this.vm.total91plus = report90;
    // console.log(this.vm.report);
  }

  selectEntityModal(entityName) {
    this.vm.request.entity_id = '';
    if (this.vm.request.entity_id == '' || 1 === 1) {
      for (const [y, value] of Object.entries(this.vm.entity)) {
        if (this.vm.entity[y].name == entityName) {
          this.vm.entityInput = entityName;
          this.vm.request.entity_id = this.vm.entity[y].id;
          this.vm.entity_email = this.vm.entity[y].email;
          this.vm.report = [];
          break;
        }
      }
    }
  }

  testEntity() {
    const entityIdStart = this.vm.request.entity_id;
    if (!this.vm.entityInput || this.vm.entityInput == '' || this.vm.entityInput == null || this.vm.entityInput === undefined) {
      this.vm.request.entity_id = '';
    } else {
      if (this.FilterObject(this.vm.entity, {name: this.vm.entityInput}).length > 0) {
        const entityId = this.FilterObject(this.vm.entity, {name: this.vm.entityInput}, true)[0].id;
        const entityName = this.FilterObject(this.vm.entity, {name: this.vm.entityInput}, true)[0].name;
        const entityEmail = this.FilterObject(this.vm.entity, {name: this.vm.entityInput}, true)[0].email;
        if (entityId != '' || entityId != null) {
          this.vm.request.entity_id = entityId;
          this.vm.entityInput = entityName;
          this.vm.entity_email = entityEmail;
        } else {
          this.vm.request.entity_id = '';
          this.vm.entity_email = '';
        }
      } else {
        this.vm.request.entity_id = '';
        this.vm.entity_email = '';
      }
    }
    if (entityIdStart != this.vm.request.entity_id) {
      this.vm.report = [];
    }
  }

  updateEntity() {
    this.vm.buttonsDisabled = true;
    this.localStorage.StorageSet('entity', '');
    this.tableDataService.getData('entity', '?state=active&pageNumber=0&pageSize=99999').subscribe((result: ResponseModel) => {
      const data: any = result.Data;
      this.vm.entity = data;
      this.vm.buttonsDisabled = false;
    });
  }

  FilterObject(value, filterObj, except = false) {
    return new FilterPipe().transform(value, filterObj);
  }
}
